import { useEffect, useState } from 'react';
import { ConditionalSnackbar, SnackbarContent } from './types';
import { toast } from '@crono-one/design-system/side-effects';

// TODO
// 1. Migrate all usages of useSnackbar to imperative API toast.success() or toast.error() from DS
// 2. Delete useSnackbar() hook
export function useSnackbar() {
  return {
    pushSnackbar: (content: SnackbarContent) => {
      switch (content.severity) {
        case 'success': {
          toast.success(content.message);
          break;
        }
        case 'error': {
          toast.error(content.message, {
            id: content.message,
          });
          break;
        }
        case 'warning': {
          toast.warning(content.message);
          break;
        }
        case 'info': {
          toast.info(content.message);
          break;
        }
        default: {
          console.error(
            `pushSnackbar was called with severity ${content.severity} which is not handled.`,
          );
          break;
        }
      }
    },
  };
}

/**
 * @deprecated Use the imperative `toast` API from
 * `@crono-one/design-system/side-effects`, or the `meta` object for React
 * Query mutations, instead.
 */
export function useConditionalSnackBar(
  conditionalSnackbar: ConditionalSnackbar[],
) {
  const { pushSnackbar } = useSnackbar();
  //This is done to save the previous state, since the conditions that we use to show the snackbars are not resetting, so they would always be true
  const [savedConditions, setSavedConditions] = useState<boolean[]>(
    new Array(conditionalSnackbar.length).fill(false),
  );
  const conditions = conditionalSnackbar.map((snackbar) => snackbar.condition);

  //Todo, maybe change the snackbars to be an array, to show more of the one above the other
  useEffect(() => {
    conditionalSnackbar.forEach((snackbar, index) => {
      const { condition, ...rest } = snackbar;
      //If the saved one is true I don't have to show the snackbar again

      //This works because when an API is called, the isSuccess (or the error) is set to null while loading, so we update the savedConditions
      //and then we can listen to the changes again, showing the error or the success message again if needed
      if (condition && !savedConditions[index]) {
        pushSnackbar(rest);
      }
    });
    setSavedConditions(conditions);
  }, [...conditions]);
}
